import React from 'react';
import { Outlet } from 'react-router';
import Page404 from '@/core/pages/Page404';
import { useTypedSelector } from '@/core/redux/hooks';
import { getSetting } from '@/core/redux/selectors/settingsManagement.selectors';
import { SettingsKeys } from '@/core/enums';
import { TenantAccountSettings } from '@/features/geomap/types';

const SubscriptionsGuard = () => {
  const tenantAccountSettings = useTypedSelector((state) =>
    getSetting<TenantAccountSettings>(state, SettingsKeys.TENANT_ACCOUNTS),
  );

  if (!tenantAccountSettings?.subscriptions?.active) {
    return <Page404 />;
  }

  return <Outlet />;
};

export default SubscriptionsGuard;
